import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";

import CaseDuplicateData from "./CaseDuplicateData";

const CaseDedupDetailsPage = () => {
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id, personID } = useParams();
  useEffect(() => {
    setIsLoading(true);
    fetch(`/api/getcaseDedup?id=${id}&person_id=${personID}`)
      .then((response) => response.json())
      .then((data) => {
        setRecords(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      });
  }, [id, personID]);

  return (
    <Box m={4}>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <CaseDuplicateData caseRecords={records} />
      )}
    </Box>
  );
};

export default CaseDedupDetailsPage;
